import React, { useState } from 'react';
import { Modal } from '../components/base';
import { PartnerDetail } from '../features/parceiros/PartnerDetail';
import { PartnerForm } from '../features/parceiros/PartnerForm';

function PartnersView({ partners, onCreatePartner, onUpdatePartner, onDeletePartner, onGeneratePortalLink, onRevokePortalLink, isAdmin }) {
  const [showForm, setShowForm]   = useState(false);
  const [editing, setEditing]     = useState(null);
  const [viewingId, setViewingId] = useState(null);
  // Sempre pega o parceiro mais atualizado do array (após onSnapshot)
  const viewing = viewingId ? partners.find(p => p.id === viewingId) : null;

  return <div className="space-y-4">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-bold text-gray-800">Parceiros</h2>
      {isAdmin && <button onClick={()=>setShowForm(true)} className="bg-blue-500 text-white text-sm px-4 py-2 rounded-full hover:bg-blue-600 font-semibold">+ Novo Parceiro</button>}
    </div>
    {showForm && <Modal title="Novo Parceiro" onClose={()=>setShowForm(false)} wide>
      <PartnerForm onSave={d=>{onCreatePartner(d);setShowForm(false);}} onCancel={()=>setShowForm(false)} />
    </Modal>}
    {editing && <Modal title={`Editar: ${editing.name}`} onClose={()=>setEditing(null)} wide>
      <PartnerForm partner={editing} onSave={d=>{onUpdatePartner(editing.id,d);setEditing(null);}} onCancel={()=>setEditing(null)} />
    </Modal>}
    {viewing && <PartnerDetail
      partner={viewing}
      isAdmin={isAdmin}
      onGeneratePortalLink={onGeneratePortalLink}
      onRevokePortalLink={onRevokePortalLink}
      onClose={()=>setViewingId(null)}
      onEdit={()=>{setEditing(viewing);setViewingId(null);}}
      onDelete={()=>{if(confirm('Excluir parceiro?')){onDeletePartner(viewing.id);setViewingId(null);}}}
    />}
    {partners.length===0
      ? <div className="text-center py-16 text-gray-400"><div className="text-4xl mb-2">🤝</div><p>Nenhum parceiro cadastrado</p></div>
      : <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {partners.map(p=>(
            <div key={p.id} onClick={()=>setViewingId(p.id)} className="acard rounded-2xl p-5 cursor-pointer hover:shadow-md transition-all">
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-gray-800 truncate">{p.name}</div>
                  {p.full_name && p.full_name!==p.name && <div className="text-xs text-gray-400 truncate">{p.full_name}</div>}
                  {p.email && <div className="text-xs text-gray-500 mt-1 truncate">{p.email}</div>}
                  {p.phone && <div className="text-xs text-gray-500 truncate">{p.phone}</div>}
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {p.cnpj && <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">CNPJ: {p.cnpj}</span>}
                    {p.cpf  && !p.cnpj && <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">CPF: {p.cpf}</span>}
                    {p.city && <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">{p.city}{p.state?` — ${p.state}`:''}</span>}
                  </div>
                </div>
                {p.default_commission > 0 && (
                  <span className="ml-3 flex-shrink-0 text-sm font-bold text-purple-700 bg-purple-50 border border-purple-200 rounded-xl px-3 py-1">{p.default_commission}%</span>
                )}
              </div>
              {p.bank_pix && <div className="mt-2 text-xs text-blue-600 truncate">PIX: {p.bank_pix}</div>}
            </div>
          ))}
        </div>}
  </div>;
}

// ─── DashboardView ────────────────────────────────────────

export { PartnersView };
